// ignore-string-externalization

import { NextPage, NextPageContext } from 'next';
import { HelpHomeTemplateType } from '../../../features/Template/Help/HelpHomeTemplate';
import { NotFound } from '../../../features/Layout';
import { getArticlePageData } from '../../../features/Help/getHelpData';
import React from 'react';
import { HelpArticleTemplate } from '../../../features/Template/Help/HelpArticleTemplate';
import { FaqArticle, FaqCategory } from '../../../features/Help/util';

const HelpListPage: NextPage<{
  template?: HelpHomeTemplateType | null;
  faq?: FaqArticle;
  category?: FaqCategory;
  preview?: boolean;
}> = ({ template, faq, category, preview }) => {
  if (!template || !faq) {
    return <NotFound />;
  }

  return (
    <HelpArticleTemplate
      template={template}
      preview={preview}
      category={category}
      article={faq}
    />
  );
};

HelpListPage.getInitialProps = async ({
  smartlingLanguage,
  preview = false,
  query,
}: NextPageContext & { preview?: boolean; smartlingLanguage: string }) => {
  return await getArticlePageData(
    query.urlSlug as string,
    preview,
    smartlingLanguage,
    query.category as string,
  );
};

export default HelpListPage;
